import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { sidebarVisibleAtom } from '../stores/layout/atoms';

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const setSidebarVisible = useSetAtom(sidebarVisibleAtom);

  useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      const modKey = isMac ? e.metaKey : e.ctrlKey;

      if (modKey && e.key === 'k') {
        e.preventDefault();
        void navigate('/chat');
      }

      if (modKey && e.key === 'p') {
        e.preventDefault();
        void navigate('/agents');
      }

      if (modKey && e.key === ',') {
        e.preventDefault();
        void navigate('/settings');
      }

      if (modKey && e.key === 'b') {
        e.preventDefault();
        setSidebarVisible((visible) => !visible);
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [navigate, setSidebarVisible]);
}

